export default "__VITE_ASSET__BLCvpPPR__"